import { render, staticRenderFns } from "./Meal.vue?vue&type=template&id=1f5f13a0&"
import script from "./Meal.vue?vue&type=script&lang=js&"
export * from "./Meal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports